import { render, staticRenderFns } from "./CourseRelationships.vue?vue&type=template&id=1b1b360e&scoped=true&"
import script from "./CourseRelationships.vue?vue&type=script&lang=js&"
export * from "./CourseRelationships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b360e",
  null
  
)

export default component.exports